import React, { useEffect, useRef } from "react";
import {
  TextContainer,
  Paragraph,
  Span,
} from "../styles/components/Global/Paragraph";
import animations from "./Animations";

const ParagraphMix = ({
  heading,
  text,
  indent = false,
  width = "large",
  size = "normal",
  padding = false,
  parallax = true,
}) => {
  const containerRef = useRef(null);
  useEffect(() => {
    if (parallax) {
      setTimeout(() => {
        animations.parallax(containerRef.current);
      }, 1000);
    }
  }, []);

  return (
    <TextContainer ref={containerRef} $padding={padding} $direction="column">
      <Paragraph $indent={indent} $width={width} $size="normal">
        <Span
          $width={width}
          $size={size}
          $style="deville"
          dangerouslySetInnerHTML={{ __html: heading }}
        ></Span>
        {text}
      </Paragraph>
    </TextContainer>
  );
};

export default ParagraphMix;
